import styled from "styled-components";

export const Event = styled.button`
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;

  padding: 1.5rem;

  border: none;
  border-right: 4px solid transparent;
  border-bottom: 1px solid #8f8f8f;

  background-color: #e5e5e5;

  &:hover {
    background-color: #f4f4f4;
    cursor: pointer;
    border-right: 1px solid #fe2f67;

    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 6px 0px 0px 6px;
    position: relative;
    z-index: 999;
  }
`;

export const FocusedEvent = styled.button`
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;

  padding: 1.5rem;

  border: none;
  border-right: 4px solid transparent;
  border-bottom: 1px solid #8f8f8f;

  background-color: #ffffff;

  cursor: pointer;
  border-right: 4px solid #fe2f67;

  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 6px 0px 0px 6px;
  position: relative;
  z-index: 998;
`;

export const EventInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 3.5rem;
  gap: 0.5rem;
`;

export const EventInfoContent = styled.div`
  display: flex;
  align-items: center;
`;

export const EventLocationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const EventImageContainer = styled.div`
  background-color: #9ba9c0;
  width: 160px;
  height: 160px;

  border-radius: 10px;
`;

export const EventImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
`;

export const EventLocation = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;

  font-size: 12px;
  color: #757575;
`;

export const EventTime = styled.p`
  font-size: 12px;
  color: #757575;
  padding-left: 8px;
  text-align: left;
`;

export const EventName = styled.p`
  color: #000000;
  font-size: 20px;
  text-align: left;
`;

export const AttendeeProfileImage = styled.img`
  background-color: #9ba9c0;
  border-radius: 50%;
  width: 44px;
  height: 44px;
`;

export const AttendeeChild = styled.div`
  display: flex;
  align-items: center;
  padding: 40px;
`;

export const AttendeeName = styled.p`
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  margin-left: 10px;
`;

export const TabContainerDetail = styled.div`
  margin: 0 auto;
  width: 100%;
  height: 120px;
  display: flex;
  align-items: end;
  background-color: #ffffff;
`;

export const CircleLabels = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  margin-right: 5px;
  margin-bottom: 8px;
`;

export const ProfileUpcomingEvents = styled.div`
  width: 100%;
  height: 341px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0px 3.79451px 3.79451px rgba(0, 0, 0, 0.25);
  position: relative;
  margin: 0 auto;
  @media (max-width: 768px) {
    height: auto;
    padding: 20px;
    box-sizing: border-box;
  }
`;

export const EventUpcomingHeader = styled.div`
  padding-top: 20px;
  padding-left: 36px;
  padding-right: 26px;
  padding-bottom: 25px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  h2 {
    color: #000000;
    font-size: 18px;
    font-weight: bold;
    line-height: 16.94px;
    text-align: left;
  }

  .see-all {
    color: #fe2f67;
    font-size: 14px;
    text-decoration: underline;
  }

  .see-all:hover {
    text-decoration: underline;
  }
`;

export const ProfileEventsContainer = styled.div`
  height: 250px;
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  gap: 46px;
  scroll-behavior: smooth; 
  background: #ffffff;
  border-radius: 20px, 20px, 0px, 0px;
  margin-left: 21px;
  margin-right: 21px;
  padding-left: 5px;
  padding-right: 5px;
  position: relative;
  box-sizing: border-box;

   @media (max-width: 768px) {
    width: 100%;
    height: 250px;
    margin: 0;
    paddin-left: 5px;
    box-sizing: border-box;
  }

  &::-webkit-scrollbar {
    height: 8px;
    padding-left: 26px;

  }

  &::-webkit-scrollbar-thumb {
    background-color: #D82C89;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #FF94B1;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: hotpink;
`;

export const ProfileEventContainer = styled.div`
  flex-shrink: 0;
  width: 191px;
  height: 221px;
  border-radius: 10px 10px 10px 10px;
  box-shadow: 0px 3.79451px 3.79451px rgba(0, 0, 0, 0.25);
  background: #ffffff;
`;

export const ProfileEventImage = styled.div`
  width: 191px;
  height: 100px;
  border-radius: 10px 10px 0px 0px;
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #757575;
  font-size: 12px;

  img {
    width: 100%;
    height: 100%;
    border-radius: 10px 10px 0px 0px;
    object-fit: cover;
  }
`;

export const ProfileEventInfo = styled.div`
  margin-left: 8px;
  margin-right: 19px;
`;

export const ProfileEventInfoContent = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;

export const ProfileEventName = styled.p`
  width: 170px;
  height: 17px;
  color: #000000;
  font-size: 14px;
  line-height: 16.94px;
  text-align: left;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  -webkit-mask-image: linear-gradient(to right, black 90%, transparent 100%);
  mask-image: linear-gradient(to right, black 90%, transparent 100%);
`;

export const ProfileDetail = styled.p`
  font-size: 10px;
  color: #000000;
  margin-bottom: 10px;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  max-height: 3em;
  min-height: 3em;
  white-space: pre-line;
`;

export const ProfileEventLocation = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  font-size: 10px;
  color: #757575;
  white-space: nowrap;
  overflow: hidden;
`;

export const ProfileEventTime = styled.p`
  font-size: 10px;
  color: #757575;
  padding-left: 8px;
  text-align: left;
`;

export const ProfileButton = styled.p`
  color: #ffffff;
  background-color: #d82c89;
  width: 118px;
  height: 21px;
  border-radius: 5px;
  font-size: 13px;
  text-align: center;
  line-height: 1.2rem;
`;

export const ProfileBottomContainer = styled.div`
  display: flex;
  margin-top: 12px;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
